import { TmdxChip } from '@ds';
import { ResourceRowData } from '@features/components/CaseOverview/components/AssignedResources/types';
import { getRenderResourceTableCell } from '@features/components/CaseOverview/components';
import { OpoContactRowData } from './utils';

export const getRenderOpoContactTableCell = (onUserAssign: (item: ResourceRowData) => void) => {
  const defaultRenderCell = getRenderResourceTableCell(onUserAssign);

  return (item: ResourceRowData, columnKey: string) => {
    if (columnKey === 'type') {
      const contact = item as OpoContactRowData;

      return (
        <TmdxChip size="sm" color={contact.isOpoUser ? 'success' : 'default'}>
          {contact.isOpoUser ? 'User' : 'Contact'}
        </TmdxChip>
      );
    }

    return defaultRenderCell(item, columnKey);
  };
};
